import { render, staticRenderFns } from "./KnProductSatCodes.vue?vue&type=template&id=1f0cfe0c&"
import script from "./KnProductSatCodes.vue?vue&type=script&lang=js&"
export * from "./KnProductSatCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports